import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Container, Header, Segment, Grid, Card, Message, Divider, List, Icon, Button } from 'semantic-ui-react';
import '../Playbook.css';

class Prospecting extends Component {
    render() {
        return (
            <Container fluid className="playbook-container">
                <h1 className="ui icon center aligned header playbook-branded-header" style={{fontFamily: 'Montserrat', textTransform: 'uppercase', color: 'rgb(35, 37, 58)', fontWeight: 600, fontSize: '38px', marginBottom: '-9px'}}>
                    <i aria-hidden="true" className="icon">
                        <img src="/static/media/logo-icon.7bb8994723bbdcd674f1.png" alt="logo-icon" style={{height: '68px', marginBottom: '-15px'}} />
                    </i>
                    Sales Activity
                </h1>
                <div className="ui divider"></div>

                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment className="playbook-content">
                                <Header as="h2" className="section-header">What is Prospecting?</Header>
                                
                                <p>
                                    Prospecting is the means of creating a new conversation with someone you don't know or 
                                    with a current customer that you are looking to protect or grow.
                                </p>

                                <Message info>
                                    <Message.Header>Two Types of Prospecting</Message.Header>
                                    <List bulleted>
                                        <List.Item><strong>New Business Development:</strong> Creating relationships with new prospects</List.Item>
                                        <List.Item><strong>Account Management:</strong> Protecting and growing existing customer relationships</List.Item>
                                    </List>
                                </Message>

                                <Divider />

                                <Header as="h2" className="section-header">Sample Cold Outreach</Header>
                                
                                <p>
                                    Let's start with a sample email (or LinkedIn DM) that can be used for you. There are all 
                                    kinds of creative ways to do it. Cold outreach can take all kinds of forms from straight 
                                    forward to catchy to creative. This is a straight forward approach that you can use and 
                                    tailor to your company.
                                </p>

                                <Message warning>
                                    <Message.Header>Important Disclaimer</Message.Header>
                                    <p>
                                        <strong>We don't recommend templates.</strong> We have an archive full of "what not to do" 
                                        and email templates are very prevalent due to name mismatches, wrong company names, etc. 
                                        These are simple to retype. Retype them. Use some variation and find your own voice 
                                        that works for you and your company. Here is something to start with.
                                    </p>
                                </Message>

                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>
                                            <Icon name="mail" />
                                            Cold Outreach Example
                                        </Card.Header>
                                        <Card.Description>
                                            <Segment basic style={{backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', padding: '15px', fontFamily: 'monospace'}}>
                                                --- Begin Example<br/><br/>
                                                
                                                Hi - My name is Ryan Robinett. I am part of the AskMultiply.com team. We have a unique 
                                                approach to sales enablement by helping companies establish repeatable patterns of 
                                                conversations that can be utilized in any prospect scenario.<br/><br/>
                                                
                                                I would like the opportunity to tell you more about Multiply and learn more about 
                                                [Company Name] and determine if there is a mutually beneficial partnership to be had.<br/><br/>
                                                
                                                Can I get 45 minutes on your calendar in the next couple weeks?<br/><br/>
                                                
                                                Thanks,<br/>
                                                Ryan Robinett<br/>
                                                ryan@askmultiply.com<br/><br/>
                                                
                                                ---End Example
                                            </Segment>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <Grid stackable columns={3} style={{marginTop: '20px', marginBottom: '20px'}}>
                                    <Grid.Row style={{display: 'flex', alignItems: 'stretch'}}>
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>What Works in This Example</Card.Header>
                                                    <Card.Description style={{flex: 1}}>
                                                        <List bulleted>
                                                            <List.Item><strong>Personal introduction</strong> - Name and company</List.Item>
                                                            <List.Item><strong>Brief value proposition</strong> - What you do in one sentence</List.Item>
                                                            <List.Item><strong>Mutual benefit language</strong> - Partnership mindset</List.Item>
                                                            <List.Item><strong>Specific ask</strong> - 45 minutes, specific timeframe</List.Item>
                                                            <List.Item><strong>Professional closing</strong> - Contact information</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>Key Principles</Card.Header>
                                                    <Card.Description style={{flex: 1}}>
                                                        <List bulleted>
                                                            <List.Item><strong>Keep it short</strong> - Respect their time</List.Item>
                                                            <List.Item><strong>Be specific</strong> - Clear ask for meeting</List.Item>
                                                            <List.Item><strong>No links</strong> - Avoid security concerns</List.Item>
                                                            <List.Item><strong>Professional tone</strong> - Business appropriate</List.Item>
                                                            <List.Item><strong>Easy response</strong> - Simple yes/no question</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>Customization Tips</Card.Header>
                                                    <Card.Description style={{flex: 1}}>
                                                        <List bulleted>
                                                            <List.Item><strong>Research the prospect</strong> - Company-specific details</List.Item>
                                                            <List.Item><strong>Reference connections</strong> - Mutual contacts if any</List.Item>
                                                            <List.Item><strong>Industry relevance</strong> - Tailor value prop</List.Item>
                                                            <List.Item><strong>Timing consideration</strong> - Industry/seasonal awareness</List.Item>
                                                            <List.Item><strong>Personal voice</strong> - Make it authentically yours</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <Divider />

                                <Header as="h2" className="section-header">Create a New Encounter</Header>
                                
                                <p>
                                    This is the bucket that many like the least. In companies with mature sales organization 
                                    with various roles, the lead generation function is often kicked the furthest down the 
                                    organization. That's fine. We have a lead gen function at Multiply as well. However, 
                                    the salesperson or an executive is often far more effective at getting a meeting than 
                                    is a lead generator.
                                </p>

                                <Message warning>
                                    <Message.Header>Our Warning</Message.Header>
                                    <p><strong>Everyone is responsible for getting a meeting.</strong></p>
                                </Message>

                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>The Reality of Prospecting</Card.Header>
                                        <Card.Description>
                                            <p>
                                                Now, with that said, staring into the great abyss of prospects can be overwhelming. 
                                                When dealing with salespeople that cover all aspects of the sales cycle, you will 
                                                find they will often avoid this prospecting bucket. It is hard work. It is a 
                                                volume-based thankless activity that yields few "successes". That's fine. 
                                                It's important to know that going in and to focus on the process and response—any response.
                                            </p>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <Grid stackable columns={2} style={{marginTop: '20px', marginBottom: '20px'}}>
                                    <Grid.Row style={{display: 'flex', alignItems: 'stretch'}}>
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid color="blue" style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>Preferred Prospecting Methods</Card.Header>
                                                    <Card.Description style={{flex: 1}}>
                                                        <p>We like LinkedIn and email the best in this scenario. That doesn't mean you 
                                                        shouldn't make phone calls because phone calls can certainly be effective. 
                                                        But ask yourself:</p>
                                                        
                                                        <List bulleted>
                                                            <List.Item>How often do you answer your phone from an "unknown" number?</List.Item>
                                                            <List.Item>Do you like talking to a salesperson unexpectedly?</List.Item>
                                                        </List>
                                                        
                                                        <p><strong>Phone calls and texts are a great way to follow up but not a great way to create a connection.</strong></p>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid color="green" style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>The Four Primary Mediums</Card.Header>
                                                    <Card.Description style={{flex: 1}}>
                                                        <p>Use every means possible to get a meeting:</p>
                                                        <List ordered>
                                                            <List.Item><strong>Email</strong> - Professional, documented communication</List.Item>
                                                            <List.Item><strong>LinkedIn messages</strong> - Professional networking platform</List.Item>
                                                            <List.Item><strong>Networking events</strong> - Face-to-face relationship building</List.Item>
                                                            <List.Item><strong>Phone calls</strong> - Direct, personal communication</List.Item>
                                                        </List>
                                                        
                                                        <p><strong>By Any Means Necessary:</strong> Prospecting is a volume-based play.</p>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <Divider />

                                <Header as="h2" className="section-header">Multiply Tip: Avoid Links and Videos</Header>
                                
                                <Message>
                                    <Message.Header>Why We Don't Recommend Sending Links</Message.Header>
                                    <p>
                                        When you reach out to a prospect, do not route them to a link on a website or to a 
                                        video of your product. Your purpose is to get that person to respond in some way. 
                                        If you give a prospect the option to go click a link, the prospect may or may not click. 
                                        And if they do click, they may watch while distracted, only watch half, not really watch, 
                                        misunderstand the message, or watch it and love it but forget to respond—or any of the 
                                        other infinite possibilities.
                                    </p>
                                    
                                    <p>
                                        So you may get the desired action you want but ultimately no response from the prospect. 
                                        It's important that when you send a message, you ask for a meeting.
                                    </p>
                                    
                                    <p>
                                        <strong>Security Concerns:</strong> Most prospects will not click on links because they may 
                                        think it's a potential phishing scheme or other potential security threat. Others operate 
                                        the same way and have sophisticated systems that will filter out your messages.
                                    </p>
                                    
                                    <p><strong>Be specific about your ask, and be simple.</strong></p>
                                </Message>

                                <Divider />

                                <Header as="h2" className="section-header">Understanding Responses</Header>
                                
                                <Card fluid className="highlight-card">
                                    <Card.Content>
                                        <Card.Header>Any Response is a Good Response</Card.Header>
                                        <Card.Description>
                                            <p>
                                                Regarding responses, any response is a good response. We want to ask for a time or at 
                                                least a binary response. When we get a "no" or some response saying "no", we at least 
                                                know we are getting through. Our ask was clear and elicited a response.
                                            </p>
                                            
                                            <p><strong>This is the world of cold outreach. We are going to get a lot of "no's".</strong></p>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <Grid stackable>
                                    <Grid.Row>
                                        <Grid.Column width={4}>
                                            <Card color="green">
                                                <Card.Content>
                                                    <Card.Header>"Yes" Response</Card.Header>
                                                    <Card.Description>
                                                        <List bulleted>
                                                            <List.Item>Schedule immediately</List.Item>
                                                            <List.Item>Confirm details</List.Item>
                                                            <List.Item>Send calendar invite</List.Item>
                                                            <List.Item>Prepare thoroughly</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column width={4}>
                                            <Card color="yellow">
                                                <Card.Content>
                                                    <Card.Header>"No" Response</Card.Header>
                                                    <Card.Description>
                                                        <List bulleted>
                                                            <List.Item>Message is getting through</List.Item>
                                                            <List.Item>Ask was clear</List.Item>
                                                            <List.Item>Add to follow-up list</List.Item>
                                                            <List.Item>Try again in 6 months</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column width={4}>
                                            <Card color="orange">
                                                <Card.Content>
                                                    <Card.Header>Argumentative Response</Card.Header>
                                                    <Card.Description>
                                                        <List bulleted>
                                                            <List.Item>Very good response!</List.Item>
                                                            <List.Item>Shows engagement</List.Item>
                                                            <List.Item>Opportunity to engage further</List.Item>
                                                            <List.Item>Potential to get meeting</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column width={4}>
                                            <Card color="red">
                                                <Card.Content>
                                                    <Card.Header>No Response</Card.Header>
                                                    <Card.Description>
                                                        <List bulleted>
                                                            <List.Item>Time to worry</List.Item>
                                                            <List.Item>Messaging may be off</List.Item>
                                                            <List.Item>Market may not be receptive</List.Item>
                                                            <List.Item>A/B test different approaches</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <Message info>
                                    <Message.Header>A/B Testing Your Approach</Message.Header>
                                    <p>
                                        We obviously want a "yes", so we should A/B test our messaging to see which messages 
                                        are generating a yes, which are generating a no, and which are generating no response. 
                                        When we go through periods of no responses, then that is when it is time to worry. 
                                        When we are not even getting a "no", it could mean that our messaging is off, we are 
                                        not being clear in what we are after, or worse, if we are a new company or launching 
                                        a new product/offering, it could mean the market is not receptive.
                                    </p>
                                </Message>

                                <Divider />

                                <Header as="h2" className="section-header">Networking Events Strategy</Header>
                                
                                <p>
                                    Email and LinkedIn messages are discussed above. When it comes to networking events, 
                                    that is where prospecting can get challenging. There are some events where people 
                                    expect to get sold to, but at the VAST majority of events, prospects do not want 
                                    to be sold to. However, that doesn't mean we can't get a meeting.
                                </p>

                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>Networking Event Rules</Card.Header>
                                        <Card.Description>
                                            <p>
                                                When we use the term "networking event", we are talking about anywhere a prospect 
                                                may be. This could be bumping into a prospect while running errands, while at a 
                                                football tailgate, or at a networking event. We treat all of these the same. 
                                                We also assume NO ONE wants to be sold to at these events.
                                            </p>
                                            
                                            <p>That just means we have to be VERY intentional about how we approach them. This means that you or your team members are prepared with the 2-minute version of your company's story. You are then VERY intentional about your ask.</p>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <Grid stackable columns={2} style={{marginTop: '20px', marginBottom: '20px'}}>
                                    <Grid.Row style={{display: 'flex', alignItems: 'stretch'}}>
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid color="green" style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>
                                                        <Icon name="checkmark" />
                                                        What TO Do at Networking Events
                                                    </Card.Header>
                                                    <Card.Description style={{flex: 1}}>
                                                        <List bulleted>
                                                            <List.Item><strong>Ask to set up a meeting</strong> to tell the prospect more</List.Item>
                                                            <List.Item><strong>Ask the prospect for their contact information</strong> so you can send them a note to set up a meeting</List.Item>
                                                            <List.Item><strong>Set the expectation</strong> that you will reach out</List.Item>
                                                            <List.Item><strong>Get permission to contact</strong> which will almost certainly generate a response to your email/text</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid color="red" style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>
                                                        <Icon name="warning sign" />
                                                        What NOT to Do at Networking Events
                                                    </Card.Header>
                                                    <Card.Description style={{flex: 1}}>
                                                        <p><strong>You DO NOT give the prospect a business card and feel like you have done your job.</strong></p>
                                                        
                                                        <p>Business cards are fine. Feel free to hand them out. But when you hand out a card, you have relinquished control of the next step.</p>
                                                        
                                                        <List bulleted>
                                                            <List.Item>If you give a card, make sure you either get a card in return</List.Item>
                                                            <List.Item>Or get the person's contact information another way</List.Item>
                                                            <List.Item>Most importantly, set the expectation that you will reach out</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <Divider />

                                <Header as="h2" className="section-header">Phone Call Strategy</Header>
                                
                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>The Reality of Cold Calling</Card.Header>
                                        <Card.Description>
                                            <p>
                                                This is not a very efficient and effective way to prospect. It's a numbers game 
                                                with low hit rate. Phone calls once were the method but have now become very 
                                                ineffective. Ask yourself, "Do I answer calls from unknown numbers when I get one?" 
                                                If you do, you are rare. Most do not, and we now have all sorts of programs to 
                                                limit them from getting through.
                                            </p>
                                            
                                            <p>
                                                And if you do answer an unknown call, do you really want to talk to a salesperson 
                                                when you are not expecting to?
                                            </p>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <Message warning>
                                    <Message.Header>If You Do Make Cold Calls</Message.Header>
                                    <p>
                                        Now, that doesn't mean don't make calls. Do call. Get a meeting "by any means necessary". 
                                        But if you or your team members do get someone on the phone, then you have to be ready to go. 
                                        This conversation can look very similar to the conversation at a networking event, where you 
                                        provide a 2-minute overview and work to get to the next and more planned meeting.
                                    </p>
                                </Message>

                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>Phone Call Challenges</Card.Header>
                                        <Card.Description>
                                            <p>
                                                If you do get someone on the phone, the prospect is likely to ask, "What do you have?" 
                                                At that point, the sales team member must be ready to tell the whole story in a succinct 
                                                manner such that you don't lose the person on the phone. This can be very difficult 
                                                because it is relatively uncontrolled, and if you have a demonstration or some sort 
                                                of technology to share, you still need to get to a meeting to conduct the demonstration.
                                            </p>
                                            
                                            <p>
                                                We don't tell people to avoid phone calls, but keep in mind that phone calls as an 
                                                initial encounter can be unpredictable. It's easy to burn your chance with a prospect 
                                                very early with a bad phone call.
                                            </p>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <Card fluid className="highlight-card">
                                    <Card.Content>
                                        <Card.Header>Predictability Preference</Card.Header>
                                        <Card.Description>
                                            <p>
                                                We prefer predictability for us—and for prospects. Whatever format you use to reach 
                                                out to a prospect—email, online tools, and/or phone calls—the key is to create 
                                                predictable meetings that allow you to:
                                            </p>
                                            
                                            <List bulleted>
                                                <List.Item>Prepare to tell the story and desired next steps</List.Item>
                                                <List.Item>Be intentional with your ask</List.Item>
                                                <List.Item>Generate a next step</List.Item>
                                            </List>
                                            
                                            <p>
                                                With a prospecting phone call, your ask will be to meet in a longer format either 
                                                online or in person, which dovetails with the next step.
                                            </p>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <Divider />

                                <Header as="h2" className="section-header">Selling to Current Customers</Header>
                                
                                <p>
                                    Many sales team members will be responsible for maintaining and building new clients. 
                                    When looking at current accounts, the first goal is to ensure they don't go backwards. 
                                    And the second goal is to grow those accounts. It can be very painful to an organization 
                                    when a key account is lost.
                                </p>

                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>Current Customer Strategy</Card.Header>
                                        <Card.Description>
                                            <p>
                                                When meeting with current customers, salespeople often find it "tricky" to figure 
                                                out what to say. Your tactic is to create a meeting on the basis of providing the 
                                                customer an update on your company.
                                            </p>
                                            
                                            <p>There usually are things that change with the overall story of your product or company 
                                            on a fairly regular basis. So if you are meeting with a client that you haven't talked 
                                            to in the last 6 months, then you can tell the client a part of the story that has 
                                            changed or some aspect of the story that the client does not know.</p>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <Grid stackable columns={2} style={{marginTop: '20px', marginBottom: '20px'}}>
                                    <Grid.Row style={{display: 'flex', alignItems: 'stretch'}}>
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>Company Updates to Share</Card.Header>
                                                    <Card.Description style={{flex: 1}}>
                                                        <List bulleted>
                                                            <List.Item><strong>New clients</strong> that have been added</List.Item>
                                                            <List.Item><strong>New service offerings</strong> that have been added or removed</List.Item>
                                                            <List.Item><strong>New offices</strong> that your company has opened</List.Item>
                                                            <List.Item><strong>Any other material changes</strong> to the company</List.Item>
                                                            <List.Item><strong>Team expansions</strong> or key personnel additions</List.Item>
                                                            <List.Item><strong>Technology improvements</strong> or system upgrades</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column style={{display: 'flex', padding: '10px'}}>
                                            <Card fluid style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                                                <Card.Content style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
                                                    <Card.Header>Your Ask with Current Customers</Card.Header>
                                                    <Card.Description style={{flex: 1}}>
                                                        <List bulleted>
                                                            <List.Item><strong>Updates or changes</strong> to the client's company</List.Item>
                                                            <List.Item><strong>How current execution</strong> of your services is going</List.Item>
                                                            <List.Item><strong>New challenges</strong> the client is facing</List.Item>
                                                            <List.Item><strong>Growth opportunities</strong> you might help with</List.Item>
                                                            <List.Item><strong>Additional stakeholders</strong> to involve</List.Item>
                                                            <List.Item><strong>Expansion possibilities</strong> within the organization</List.Item>
                                                        </List>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <Message success>
                                    <Message.Header>Dual Purpose Strategy</Message.Header>
                                    <p>
                                        This type of conversation not only maintains the business relationship by showing that 
                                        you care about the current state of the relationship, but it also gives you an opportunity 
                                        to create growth. In the same way that you approach a new prospect, you want to create 
                                        targeted asks for a current client. These would be based on new offerings that your 
                                        company may be able to provide the client that they are not currently purchasing.
                                    </p>
                                </Message>

                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default observer(Prospecting);